import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SuggestionsVisibilityState {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}

/** Whether the person hid the chat suggestions, kept across reloads. */
export const useSuggestionsVisibility = create<SuggestionsVisibilityState>()(
  persist(
    (set) => ({
      hidden: false,
      setHidden: (hidden) => set({ hidden }),
    }),
    {
      name: 'chat-suggestions-visibility',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ hidden: state.hidden }),
    },
  ),
);

/** Read outside React, by the suggestions fetch. */
export const areSuggestionsHidden = () => useSuggestionsVisibility.getState().hidden;

export function useSuggestionsHidden(): [hidden: boolean, setHidden: (hidden: boolean) => void] {
  const hidden = useSuggestionsVisibility((state) => state.hidden);
  const setHidden = useSuggestionsVisibility((state) => state.setHidden);
  return [hidden, setHidden];
}
